import { Typography, Box } from '@mui/material';
import type { BackupJob, RestoreJob, ScanJob } from '@repo/api-gw-sdk';

import { SidePanelPropsTable } from '@/components/panels/instance/tabs/sidePanelPropsTable';
import { useFields } from '@/components/table/hooks';
import type { FilterProperty } from '@/types/advanceFilter';

import { getJobType } from './jobTypeCell';

export const JobItemFields = ({
  job,
  fields,
}: {
  job: BackupJob | RestoreJob | ScanJob;
  fields: FilterProperty[];
}) => {
  const jobFields = useFields(fields, job);

  return (
    <Box className='pt-[40px]'>
      <Typography
        className='px-[40px]'
        variant='h2'
        data-testid='side-panel-resource-name'
      >
        {getJobType(job)}
      </Typography>
      <SidePanelPropsTable className='mt-[24px] mb-[24px]'>
        <tbody>
          {jobFields.map((field) => (
            <tr key={field.id}>
              <td className='props-col'>{field.title}</td>
              <td className='break-all'>{field.Component}</td>
            </tr>
          ))}
        </tbody>
      </SidePanelPropsTable>
    </Box>
  );
};
